module.exports = __webpack_public_path__ + "img/meet-your-side-kicks-overlay.3707a867.png";